<pr-color-panel display="warning" variant="colored">
  <div class="ceilings">
    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    <div>
      <p class="mb-15 in-bold">
        Les régimes micro sont soumis à des plafonds de recettes annuelles :
      </p>
      <ul>
        <li>Micro-foncier : 15 000 € de revenus fonciers bruts ;</li>
        <li>
          Micro-BIC : 83 600 € (77 700 € pour les revenus 2025) pour l'ensemble
          des locations meublées, dont 15 000 € au plus pour les meublés de
          tourisme non classés.
        </li>
      </ul>
      <p>
        Le régime réel ne s'applique qu'après deux années consécutives de
        dépassement.
      </p>
    </div>
  </div>
</pr-color-panel>
